import React from "react";
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaTwitter, FaFacebookF, FaPinterestP, FaInstagram, FaWhatsapp, FaLinkedin } from "react-icons/fa";
import "../Styles/Footer.css";
import leafIcon from "../assets/Header-Images/Vector.png";
import logoImg from "../assets/Header-Images/gics_newlogo.png"
import { useNavigate } from "react-router-dom";
import twitterImg from "../assets/social-media/twit3.jpg"
import fbImg from "../assets/social-media/facebook.png"
import instaImg from "../assets/social-media/instagrame.jpg"
import pinImg from "../assets/social-media/pintrest.avif"
import whatsappImg from "../assets/social-media/whatsapp.jpg"
import linkdinImg from "../assets/social-media/linkdin.avif"

const Footer = () => {
    const navigate = useNavigate();
    return (
      <footer className="footer">
        <div className="footer-container">
          {/* Left Section - Company Info */}
          <div className="footer-section company-info">
            <h2 className="footer-logo">
              <img src={logoImg} alt="GICS Logo" className="footer-logo-img" />{" "}
              <span className="footer-logo-text">
                Globe International Crop Science
              </span>
            </h2>
            <p className="footer-text">
              We are an agricultural company, leading in crop protection
              solutions, with a positive approach, saying
              <br /> <strong>“WE CARE FOR YOUR FIELD.”</strong>
            </p>
          </div>

          {/* Middle Section - Links */}
          <div className="footer-section links">
            <div className="footer-column">
              <h3>About Us</h3>
              <ul>
                <li onClick={() => navigate("/aboutus")}>
                  <img src={leafIcon} alt="leaf" className="icon-img" /> Company
                  History
                </li>
                <li onClick={() => navigate("/whyChooseUs")}>
                  <img src={leafIcon} alt="leaf" className="icon-img" /> Why
                  Choose Us
                </li>
              </ul>
            </div>

            <div className="footer-column">
              <h3>Products</h3>
              <ul>
                <li onClick={() => navigate("/products/Herbicides")}>
                  <img src={leafIcon} alt="leaf" className="icon-img" />{" "}
                  Herbicides
                </li>
                <li onClick={() => navigate("/products/Fungicides")}>
                  <img src={leafIcon} alt="leaf" className="icon-img" />{" "}
                  Fungicides
                </li>
                <li
                  onClick={() =>
                    navigate(
                      `/products/${encodeURIComponent(
                        "Insecticides/Pesticides"
                      )}`
                    )
                  }
                >
                  <img src={leafIcon} alt="leaf" className="icon-img" />{" "}
                  Pesticides / Insecticides
                </li>

                <li onClick={() => navigate("/products/Plant Growth Promoter")}>
                  <img src={leafIcon} alt="leaf" className="icon-img" />
                  Plant Growth Promoter{" "}
                </li>
                <li onClick={() => navigate("/products/Liquid water soluble")}>
                  <img src={leafIcon} alt="leaf" className="icon-img" />
                  Liquid Water Soluble{" "}
                </li>
                {/* <li onClick={() => navigate('/products')}><img src={leafIcon} alt="leaf" className="icon-img" /> Growth Promoter</li> */}
              </ul>
            </div>
          </div>

          {/* Right Section - Contact Info */}
          <div className="footer-section contact">
            <h3>Contact</h3>
            <p>
              <FaPhone /> +91 9826273330
            </p>
            <h3>Toll Free Contact</h3>
            <p>
              <FaPhone /> 1800-121-2016
            </p>
            <p>
              <FaEnvelope />
              globecrop@gmail.com
            </p>
            <p style={{ display: "flex", alignItems: "flex-start", gap: "10px" }}>
              <FaMapMarkerAlt style={{ marginTop: "5px", flexShrink: 0 }} /> 6-6-99, GROUND FLOOR, SAI BABA NAGAR, KATTEDAN, KATEDHAN, RAJENDRANAGAR, RANGAREDDY, TELANGANA 500019.
            </p>

            {/* Social Icons */}
            <div className="social-icons">
              <a
                href="https://www.facebook.com/share/1BfxobKATd/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={fbImg} alt="Facebook" className="social-icon-img" />
              </a>
              <a
                href="https://pinterest.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={pinImg} alt="Pinterest" className="social-icon-img" />
              </a>
              <a
                href="https://www.instagram.com/globeinternationalcropscience?igsh=MWd2eXpicnIyazNq"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={instaImg}
                  alt="Instagram"
                  className="social-icon-img"
                />
              </a>
              <a
                href="https://wa.me/+919826273330"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={whatsappImg}
                  alt="WhatsApp"
                  className="social-icon-img"
                />
              </a>
              <a
                href="https://www.linkedin.com/company/106375278/admin/dashboard/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={linkdinImg}
                  alt="LinkedIn"
                  className="social-icon-img"
                />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="footer-bottom">
          <p>
            © 2024-25 Copyrights by Globe International Crop Science. All Rights
            Reserved
          </p>
          <div className="footer-links">
            <a href="#">Terms of Use</a> | <a href="#">Privacy Policy</a>
          </div>
        </div>
      </footer>
    );
};

export default Footer;
